import { render, staticRenderFns } from "./WhyQawaemSection.vue?vue&type=template&id=0ad65743&scoped=true&"
import script from "./WhyQawaemSection.vue?vue&type=script&lang=js&"
export * from "./WhyQawaemSection.vue?vue&type=script&lang=js&"
import style0 from "./WhyQawaemSection.vue?vue&type=style&index=0&id=0ad65743&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad65743",
  null
  
)

export default component.exports